<template>
  <!-- fi-plan-board: the root hook the midnight skin scopes the planned-board
       rules on. its siblings all carry it; this page was missed. -->
  <div class="fi-plan-board" :class="{ 'fi-plan-board--midnight': midnightActive }" style="margin:20px">

    <FiPageRail title="Planned - Vehicle Utilization Weekly" />

    <div style="position: relative; font-size: 22px; font-weight: bold;" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;|&nbsp;&nbsp;Overnight Offset: &nbsp;<b-form-select v-model="selected_hours_offset" :options="hours_offset_options" style="font-size: 18px; font-weight: bold; width:100px"/>
      &nbsp;&nbsp;|&nbsp;&nbsp;<b-form-select v-model="vehicle_mode" :options="vehicle_mode_options" style="font-size: 18px; font-weight: bold; width:120px"/>
      &nbsp;&nbsp;<b-button v-on:click.prevent="load_data()">Search</b-button>
    </div>
    <br/>
    <div v-if="!loading">
      <div class="row" style="margin: 10px; font-weight: bold; font-size: 20px; flex-wrap: nowrap; overflow-x: auto;">
        <template v-for="type_stat in summary.vehicle_type_stats">
          <template v-if="vehicle_mode === 'all' || (type_week_counts[type_stat.type] || {})[vehicle_mode] > 0">
            <div v-if="selected_types.indexOf(type_stat.type) > -1" @click="filter_by_type(type_stat.type)" class="col" :style="typeChipStyle(type_stat.color, true)">{{type_stat.total_cnt}} - {{type_stat.type}}<template v-if="vehicle_mode === 'booked'"> [{{type_week_counts[type_stat.type][vehicle_mode]}}]</template></div>
            <div v-else @click="filter_by_type(type_stat.type)" class="col" :style="typeChipStyle(type_stat.color)">{{type_stat.total_cnt}} - {{type_stat.type}}<template v-if="vehicle_mode === 'booked'"> ({{type_week_counts[type_stat.type][vehicle_mode]}})</template></div>
          </template>
        </template>
      </div>
      <br/>
      <div class="align-right d-flex justify-content-center" style='display: flex; flex-wrap: nowrap'>
        <div  style="min-width: 250px; max-width: 250px !important; border: 1px solid black; margin-top:5px" v-for="(day_record,day_idx) in items">
          <div style="background-color: #eee; border-bottom: 2px solid black;font-weight: bold; font-size:22px; text-align:center">{{day_record.date_month}}/{{day_record.date_day}} - {{day_record.date_weekday}}</div>
          <template v-for="vehicle in day_record.vehicles">
            <template v-if="(!selected_types.length || selected_types.indexOf(vehicle.vehicle_type) > -1) && (vehicle_mode === 'all' || (vehicle_mode === 'booked' ? (vehicle.assignments && vehicle.assignments.length > 0) : (!vehicle.assignments || vehicle.assignments.length === 0)))">
              <div style="text-align: center; margin: 2px; padding: 4px;" :style='getStyleForVehicleID(vehicle.colorcode)' v-on:click="toggle_div(vehicle.vehicleID)"><b>{{vehicle.vehicleID | trim(20)}}</b></div>
              <div :style="vehicle_mode === 'booked' && vehicle_expanded == vehicle.vehicleID ? 'text-align: left;min-height: 120px; border: 1px dotted darkgrey; margin: 8px; padding: 2px;' : 'display:none'">
                <span v-for="item in vehicle.assignments">
                    <div style="padding: 5px !important; margin: 3px !important; padding: 0px !important">
                      <div v-if="item.charterID">
                        &nbsp;&nbsp;<b>BookingID:</b> {{item.bookingID}}<br/>
                        &nbsp;&nbsp;<b>Start:</b> {{item.start_datetime | formatDateTimeSmall(item.timezone)}}<br/>
                        &nbsp;&nbsp;<b>Finish:</b> {{item.finish_datetime | formatDateTimeSmall(item.timezone)}}
                      </div>
                    </div>
                  </span>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

  </div>

</template>
<script>
import {get_tbn_vehicle_calendar} from '../networking/tbn_apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'
import typeChipColors from '@/helpers/type_chip_colors'

export default {
  name: 'planned_vehicle_weekly_tbn',

  mixins: [typeChipColors],

  components: {
  },

  data() {
    return {
      items: [],
      summary: [],
      loading: true,
      details_fromDate: justDate(moment()),
      selected_types: [],
      vehicle_expanded: null,
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
      vehicle_mode: 'all',
      vehicle_mode_options: [
        { text: 'All', value: 'all' },
        { text: 'Booked', value: 'booked' },
        { text: 'Available', value: 'available' },
      ],
      selected_hours_offset: '',
      hours_offset_options: [
        { value: '0', text: 'None' },
        { value: '1', text: '1AM' },
        { value: '2', text: '2AM' },
        { value: '3', text: '3AM' },
        { value: '4', text: '4AM' },
        { value: '5', text: '5AM' },
        { value: '6', text: '6AM' },
      ],
    }
  },
  async created() {
    this.check_features()
  },
  methods: {
    async check_features() {
      this.load_data()
    },
    showHighlightsForDate(movements) {
      for(const item of movements) {
        item.isHighlightsVisible = !item.isHighlightsVisible;
      }
      this.$forceUpdate();
    },
    filter_by_type(type) {
      const idx = this.selected_types.indexOf(type)
      if (idx > -1) {
        this.selected_types.splice(idx, 1)
      } else {
        this.selected_types.push(type)
      }
    },
    showDetailsForDate(movements) {
      for(const item of movements) {
        item.isVisible = !item.isVisible;
      }
      this.$forceUpdate();
    },
    toggle_div(item,field) {
      if (this.vehicle_expanded == item)
          this.vehicle_expanded = null;
      else
          this.vehicle_expanded = item;
      this.$forceUpdate();
    },
    async load_data() {

      this.loading = true
      try {
        const { value: { data = [] }} = await get_tbn_vehicle_calendar(this.user.tenant, this.selected_hours_offset, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.selected_hours_offset = this.summary.hours_offset
        this.items = data.results
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    // FI-2174: the fill is remapped for midnight in the shared helper
    getStyleForVehicleID(color) {
      return this.typePillStyle(color)
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    }
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
    type_week_counts() {
      // count unique vehicle IDs per type per mode across all 7 days
      const sets = {}
      for (const day of (this.items || [])) {
        for (const vehicle of (day.vehicles || [])) {
          const t = vehicle.vehicle_type
          if (!t) continue
          if (!sets[t]) sets[t] = { booked: new Set(), available: new Set() }
          if (vehicle.assignments && vehicle.assignments.length > 0) {
            sets[t].booked.add(vehicle.vehicleID)
          } else {
            sets[t].available.add(vehicle.vehicleID)
          }
        }
      }
      const result = {}
      for (const [t, s] of Object.entries(sets)) {
        result[t] = { booked: s.booked.size, available: s.available.size }
      }
      return result
    },
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    details_fromDate(target_from_date) {
      this.details_fromDate = target_from_date
      this.details_toDate = justDate(moment(target_from_date,'MM-DD-YYYY').add(27, 'days'));
      this.load_data();
    }
  }
}
</script>

<style>
.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }
</style>
